import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box, Text, Heading, Image } from '@front/gatsby-ui';
import pluralize from 'pluralize';
import AnimatedNumber from 'animated-number-react';

import bgStatFirst from 'Img/pic_stat--first.svg';
import bgStat from 'Img/pic_stat.svg';
import bgStatLast from 'Img/pic_stat--last.svg';
import users from 'Img/ic_users.svg';
import fileCheck from 'Img/ic_file-check.svg';
import star from 'Img/ic_star.svg';
import userCheck from 'Img/ic_user-check.svg';

const formatValue = value => value.toFixed(0);

const getStatProp = {
  orders_count: value => ({
    title: (
      <AnimatedNumber
        value={value}
        formatValue={formatValue}
      />
    ),
    text: `${pluralize('Order', value)} completed`,
    bg: bgStat,
    img: fileCheck,
  }),
  quality_score: value => ({
    title: (
      <AnimatedNumber
        value={value}
        formatValue={v => v.toFixed(2)}
      />
    ),
    text: 'Average quality score',
    bg: bgStatFirst,
    img: star,
  }),
  writers_count: count => ({
    title: (
      <AnimatedNumber
        value={count}
        formatValue={formatValue}
      />
    ),
    text: `${pluralize('Expert', count)} active`,
    bg: bgStat,
    img: users,
  }),
  reviews_qty: value => ({
    title: (
      <AnimatedNumber
        value={value}
        formatValue={formatValue}
      />
    ),
    text: `${pluralize('Review', value)}`,
    bg: bgStatLast,
    img: userCheck,
  }),
};

const Item = ({ name, value }) => {
  if (!getStatProp[name]) {
    return null;
  }

  const { title, text, bg, img } = getStatProp[name](value);

  return (
    <Flex
      alignItems="center"
      flex="1 0 auto"
      width={{ _: '256px', md: '400px', xl: '256px' }}
      justifyContent={{ _: 'center', xl: 'baseline' }}
      height="141px"
      mr={{ _: 0, xl: 1 }}
      mb={{ _: 3, xl: 0 }}
      sx={{
        padding: '0 16px 16px',
        backgroundImage: `url(${bg})`,
        backgroundPosition: ['center', null, null, null, null, '0 0'],
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Image
        src={img}
        alt={text}
        mr={3}
      />

      <Box>
        <Heading
          as="h3"
          variant="h3"
          color="secondary.0"
        >
          {title}
        </Heading>

        <Text color="basic.4">{text}</Text>
      </Box>
    </Flex>
  );
};

Item.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};

export default Item;
